const productData = [
  {
    id: 1,
    name: "GOLDEN ARC STEP-LINK BRACELET",
    category: "Bracelets",
    price: "1560.00",
    reviews: "342",
    rating: "4.6",
    image: "/img/tuddle-101.png",
    images: ["/img/tuddle-101.png"],
    size: ["One Size"],
    colors: ["Yellow Gold"],
    material: "14k Yellow Gold",
    description: [
      "A refined gold bracelet built from a rhythmic sequence of stepped geometric links.",
      "Crafted from solid 14k yellow gold for lasting wear and enduring elegance.",
      "Polished borders and finely brushed recesses create a subtle play of texture.",
      "Perfect for stacking with other bracelets or wearing alone as a statement piece.",
      "Hand-finished to ensure every detail is perfectly executed with exceptional craftsmanship.",
    ],
    Features: [
      "Solid 14k yellow gold construction",
      "Original stepped-link pattern",
      "Secure clasp closure",
      "Hand-polished finish",
      "Timeless, versatile design",
      "Suitable for everyday wear or special occasions",
      "Comfortable fit",
      "Hypoallergenic materials",
    ],
  },
  {
    id: 2,
    name: "VICTORIAN MASQUERADE CAMEO",
    category: "Vintage",
    price: "2800.00",
    reviews: "289",
    rating: "4.7",
    image: "/img/tuddle-102.png",
    images: ["/img/tuddle-102.png", "/img/tuddle-102a.png"],
    size: ["One Size"],
    colors: ["Shell Cameo", "Gold"],
    material: "Vintage Shell Cameo, 14k Gold",
    description: [
      "A Victorian-inspired shell cameo centered on an abstract masquerade motif.",
      "The layered carving combines a half-mask, flowing ribbon, and a small guiding star.",
      "A slim beaded 14k gold frame gives the oval silhouette a softly antique character.",
      "Designed as an expressive pendant for collectors of narrative jewelry.",
      "Natural variations in shell tone and carving make every finished piece distinctive.",
    ],
    Features: [
      "Victorian-inspired shell cameo",
      "Original masquerade motif",
      "14k gold setting",
      "Exceptional hand-carved details",
      "Antique-inspired presentation",
      "Naturally varied shell surface",
      "Secure pendant setting",
      "Protective presentation box included",
    ],
  },
  {
    id: 3,
    name: "SOLAR HALO DIAMOND TRIO RING",
    category: "Rings",
    price: "18400.00",
    reviews: "214",
    rating: "4.5",
    image: "/img/tuddle-103.png",
    images: ["/img/tuddle-103.png", "/img/tuddle-103a.png"],
    size: ["4", "5", "6", "7", "8", "9", "10"],
    colors: ["White Gold", "Yellow Gold"],
    material: "18k Gold, Natural Diamonds",
    description: [
      "Three graduated round diamonds form a balanced constellation across the finger.",
      "Fine sunray halos frame each stone and add crisp texture to the polished setting.",
      "Crafted in luxurious 18k gold with meticulous attention to every detail.",
      "The low-profile composition is designed to feel luminous without excessive height.",
      "Perfect as an engagement ring, anniversary gift, or special occasion piece.",
    ],
    Features: [
      "Three natural diamonds of exceptional quality",
      "Graduated solar-halo design",
      "18k gold setting",
      "Handcrafted setting",
      "Individually set natural diamonds",
      "Customizable metal color",
      "Available in multiple ring sizes",
      "Care guidance included",
    ],
  },
  {
    id: 4,
    name: "DESERT RIVER TURQUOISE BRACELET",
    category: "Bracelets",
    price: "2600.00",
    reviews: "178",
    rating: "4.6",
    image: "/img/tuddle-104.png",
    images: ["/img/tuddle-104.png", "/img/tuddle-104a.png", "/img/tuddle-104b.png"],
    size: ["Small", "Medium", "Large"],
    colors: ["Turquoise", "Silver"],
    material: "Sterling Silver, Natural Turquoise",
    description: [
      "A stunning bracelet featuring baguette-cut turquoise stones in an elegant linear design.",
      "The varied turquoise tones evoke open skies, desert stone, and winding waterways.",
      "Set in polished sterling silver with clean, modern lines.",
      "Each turquoise stone is carefully selected for its rich color and matrix patterns.",
      "A wearable piece of art that celebrates the beauty of the American Southwest.",
    ],
    Features: [
      "Natural turquoise baguette stones",
      "Sterling silver setting",
      "Southwestern inspired design",
      "Secure lobster claw clasp",
      "Hand-set stones",
      "Adjustable length options",
      "Comfortable fit",
      "Each stone is unique with natural matrix",
    ],
  },
  {
    id: 5,
    name: "KEEPSAKE ATLAS COIN CHARM",
    category: "Charms",
    price: "1150.00",
    reviews: "305",
    rating: "4.8",
    image: "/img/tuddle-105.png",
    images: ["/img/tuddle-105.png", "/img/tuddle-105a.png"],
    size: ["One Size"],
    colors: ["Gold", "Silver"],
    material: "14k Gold or Sterling Silver",
    description: [
      "A round keepsake charm created to mark the places and journeys that shape us.",
      "Raised contour lines, a horizon, and a small compass star form an original landscape.",
      "Available in both 14k gold and sterling silver to suit your preference.",
      "A thoughtful way to commemorate a meaningful trip, memory, or loved one.",
      "Add to a necklace or bracelet to create a personal, meaningful collection.",
    ],
    Features: [
      "Available in 14k gold or sterling silver",
      "Original abstract landscape relief",
      "Suitable for necklaces or bracelets",
      "Hand-finished details",
      "Compass-star detail",
      "Perfect for gifting",
      "Personalizable collection",
      "Timeless keepsake design",
    ],
  },
  {
    id: 6,
    name: "CRIMSON NOCTURNE RUBY DROP EARRINGS",
    category: "Earrings",
    price: "2600.00",
    reviews: "198",
    rating: "4.4",
    image: "/img/tuddle-106.png",
    images: ["/img/tuddle-106.png"],
    size: ["One Size"],
    colors: ["Ruby", "Ebony Wood", "Gold"],
    material: "14k Gold, Natural Ruby, Ebony Wood",
    description: [
      "A sculptural pair of earrings featuring pear-shaped rubies with a combined weight of approximately .96ct.",
      "Each ruby is framed in gold and suspended below a hand-shaped arc of ebony wood.",
      "Combines the warmth of gold, the richness of wood, and the passion of ruby.",
      "The contrast of warm metal, dark wood, and crimson stone creates a dramatic rhythm.",
      "A distinctive statement for evening wear or a refined monochrome look.",
    ],
    Features: [
      ".96ct natural pear-shaped ruby",
      "Responsibly sourced ebony wood accents",
      "14k gold setting",
      "Original curved drop design",
      "Secure post backing",
      "Naturally varied wood grain",
      "Exceptional craftsmanship",
      "Protective presentation box included",
    ],
  },
  {
    id: 7,
    name: "SCULPTED KISS PENDANT NECKLACE",
    category: "Necklaces",
    price: "930.00",
    reviews: "240",
    rating: "4.7",
    image: "/img/tuddle-107.png",
    images: ["/img/tuddle-107.png", "/img/tuddle-107a.png"],
    size: ["16\"", "18\"", "20\"", "22\""],
    colors: ["Gold", "Silver"],
    material: "14k Gold or Sterling Silver",
    description: [
      "A playful yet sophisticated necklace featuring a beautifully crafted lip pendant.",
      "The lip motif is sculpted with exceptional attention to detail and dimension.",
      "Available in both warm 14k gold and cool sterling silver finishes.",
      "A conversation-starting piece that adds personality to any outfit.",
      "Perfect for expressing yourself or gifting to someone special.",
    ],
    Features: [
      "Sculpted lip pendant design",
      "Available in 14k gold or sterling silver",
      "Adjustable chain length",
      "Hand-polished finish",
      "Comfortable to wear",
      "Unique statement piece",
      "Secure lobster claw clasp",
      "Gift-ready packaging",
    ],
  },
  {
    id: 8,
    name: "GOLDEN ORBIT BEAD STATION CHAIN",
    category: "Necklaces",
    price: "975.00",
    reviews: "190",
    rating: "4.8",
    image: "/img/tuddle-108.png",
    images: ["/img/tuddle-108.png"],
    size: ["16\"", "18\"", "20\"", "24\"", "30\""],
    colors: ["Yellow Gold", "White Gold", "Rose Gold"],
    material: "14k Gold",
    description: [
      "An elegant station chain featuring evenly spaced beads for a timeless look.",
      "The beaded stations add subtle texture and interest to the classic chain design.",
      "Crafted in 14k gold with your choice of yellow, white, or rose gold.",
      "Perfect worn alone for minimalist elegance or layered with other necklaces.",
      "A wardrobe staple that transitions seamlessly from day to evening.",
    ],
    Features: [
      "14k gold construction",
      "Evenly spaced beaded stations",
      "Multiple length options",
      "Choice of gold color",
      "Smooth, polished finish",
      "Versatile layering piece",
      "Secure spring ring clasp",
      "Durable, everyday wear",
    ],
  },
  {
    id: 9,
    name: "OPEN SPAN ARCHITECTURAL BAND",
    category: "Rings",
    price: "2800.00",
    reviews: "256",
    rating: "4.7",
    image: "/img/tuddle-109.png",
    images: ["/img/tuddle-109.png", "/img/tuddle-109a.png"],
    size: ["4", "5", "6", "7", "8", "9", "10", "11", "12"],
    colors: ["Yellow Gold", "White Gold", "Platinum"],
    material: "18k Gold or Platinum",
    description: [
      "A clean architectural band defined by three asymmetric open arches.",
      "Smooth structural ribs create depth while keeping the upper profile airy.",
      "Available in luxurious 18k gold or platinum for lasting quality.",
      "Perfect as a wedding band, anniversary ring, or meaningful everyday piece.",
      "The open-span motif suggests connection, balance, and forward movement.",
    ],
    Features: [
      "Original open-span design",
      "Available in 18k gold or platinum",
      "Multiple metal options",
      "Comfort fit interior",
      "Hand-finished details",
      "Symbolic design element",
      "Suitable for stacking",
      "Care guidance included",
    ],
  },
  {
    id: 10,
    name: "TIDAL CURVE EAR CUFF",
    category: "Earrings",
    price: "1430.00",
    reviews: "312",
    rating: "4.9",
    image: "/img/tuddle-1010.png",
    images: ["/img/tuddle-1010.png", "/img/tuddle-1010a.png", "/img/tuddle-1010b.png"],
    size: ["One Size"],
    colors: ["Gold", "Silver", "Rose Gold"],
    material: "14k Gold or Sterling Silver",
    description: [
      "A sleek, modern ear cuff featuring elegant, fluid curves that hug the ear.",
      "The minimalist design creates a sophisticated look with effortless style.",
      "No piercing required - simply slide onto the ear for instant elegance.",
      "Available in multiple metal finishes to complement any skin tone and style.",
      "Perfect for adding an edgy yet refined touch to your look.",
    ],
    Features: [
      "Fluid curve design",
      "No piercing required",
      "Available in multiple metals",
      "Comfortable, secure fit",
      "Minimalist aesthetic",
      "Versatile styling options",
      "Hand-polished finish",
      "Lightweight and comfortable",
    ],
  },
  {
    id: 11,
    name: "LYRIC DUET GEMSTONE RING",
    category: "Rings",
    price: "3035.00",
    reviews: "198",
    rating: "4.6",
    image: "/img/tuddle-1011.png",
    images: ["/img/tuddle-1011.png", "/img/tuddle-1011a.png"],
    size: ["4", "5", "6", "7", "8", "9", "10"],
    colors: ["Yellow Gold", "White Gold"],
    material: "18k Gold, Precious Gemstones",
    description: [
      "Two differently shaped gemstones meet across a subtle open space in this expressive ring.",
      "A violet oval and coral-toned pear create a lively duet of color and proportion.",
      "Tiny accent stones trace one shoulder of the polished 18k gold band.",
      "Designed as a commitment ring, celebration piece, or personal color signature.",
      "The open composition represents two voices held in balance.",
    ],
    Features: [
      "Original two-gem open composition",
      "18k gold construction",
      "Precious gemstone accents",
      "Contrasting gemstone shapes",
      "Handcrafted setting",
      "Available in multiple sizes",
      "Customizable gemstones",
      "Meaningful keepsake",
    ],
  },
  {
    id: 12,
    name: "RADIANT IDENTITY DIAMOND PENDANT",
    category: "Necklaces",
    price: "4230.00",
    reviews: "267",
    rating: "4.5",
    image: "/img/tuddle-1012.png",
    images: ["/img/tuddle-1012.png"],
    size: ["18\"", "20\"", "24\""],
    colors: ["Yellow Gold", "White Gold"],
    material: "18k Gold, Diamonds",
    description: [
      "Two interweaving gold ribbons form an open oval with a calm, balanced silhouette.",
      "Five small diamonds follow one inner arc for a restrained line of light.",
      "The original design reflects individuality, connection, and self-expression.",
      "Wear it as a personal talisman or give it to mark a meaningful milestone.",
      "A delicate chain keeps the sculptural pendant at the center of attention.",
    ],
    Features: [
      "Original interwoven-ribbon design",
      "18k gold construction",
      "Natural diamond accents",
      "Symbol of connection and identity",
      "Multiple chain lengths",
      "Choice of gold color",
      "Hand-set stones",
      "Gift-ready packaging",
    ],
  },
  {
    id: 13,
    name: "POET'S FLAME GEMSTONE PENDANT",
    category: "Necklaces",
    price: "4230.00",
    reviews: "223",
    rating: "4.6",
    image: "/img/tuddle-1013.png",
    images: ["/img/tuddle-1013.png"],
    size: ["18\"", "20\"", "24\""],
    colors: ["Yellow Gold", "Rose Gold"],
    material: "18k Gold, Precious Gemstones",
    description: [
      "A slender asymmetrical flame frames three graduated gemstones in a lyrical composition.",
      "Garnet, peach moonstone, and violet sapphire create a warm-to-cool progression.",
      "Crafted in 18k gold with a light open profile and softly polished curves.",
      "The original motif celebrates creative energy and the courage to speak in your own voice.",
      "A meaningful choice for lovers of color, art, and expressive jewelry.",
    ],
    Features: [
      "Original asymmetrical flame design",
      "18k gold setting",
      "Precious gemstone accents",
      "Three-color gemstone composition",
      "Multiple chain lengths",
      "Choice of gold colors",
      "Handcrafted details",
      "Symbol of creative energy",
    ],
  },
  {
    id: 14,
    name: "UNITY DIAMOND SIGNET RING",
    category: "Rings",
    price: "3200.00",
    reviews: "198",
    rating: "4.7",
    image: "/img/tuddle-1014.png",
    images: ["/img/tuddle-1014.png", "/img/tuddle-1014a.png"],
    size: ["4", "5", "6", "7", "8", "9", "10", "11"],
    colors: ["Yellow Gold", "White Gold", "Platinum"],
    material: "18k Gold or Platinum, Diamonds",
    description: [
      "A modern signet ring with a softly rectangular face shaped for everyday wear.",
      "Flowing recessed channels cross the surface beside a small diamond constellation.",
      "Available in luxurious 18k gold or platinum for exceptional quality and durability.",
      "Designed as a commitment ring, milestone gift, or personal symbol of unity.",
      "Its bold face and smooth comfort band balance presence with practical wearability.",
    ],
    Features: [
      "Original channelled signet design",
      "Available in 18k gold or platinum",
      "Natural diamond accents",
      "Comfort fit band",
      "Multiple size options",
      "Customizable metal choice",
      "Handcrafted setting",
      "Symbol of unity and connection",
    ],
  },
  {
    id: 15,
    name: "GOLDEN MERIDIAN STEP-LINK COLLAR",
    category: "Necklaces",
    price: "2850.00",
    reviews: "312",
    rating: "4.8",
    image: "/img/tuddle-1015.png",
    images: ["/img/tuddle-1015.png", "/img/tuddle-1015a.png"],
    size: ["14\"", "16\"", "18\""],
    colors: ["Yellow Gold"],
    material: "14k Yellow Gold",
    description: [
      "A sculptural collar composed of alternating polished rectangles and stepped fan-shaped links.",
      "Sits elegantly at the collarbone for a sophisticated, statement-making look.",
      "Crafted from solid 14k yellow gold with exceptional attention to detail.",
      "Finely brushed centers contrast with polished borders as the articulated links move.",
      "Perfect for elevating evening wear or adding glamour to daytime looks.",
    ],
    Features: [
      "Solid 14k yellow gold",
      "Original meridian step-link pattern",
      "Elegant collar length",
      "Intricate detailing",
      "Statement piece",
      "Comfortable fit",
      "Secure clasp",
      "Hand-polished finish",
    ],
  },
];

export default productData;
